import { useMemo } from "react";
import { useMedicalCareContext } from "@/contexts/MedicalCareContext";
import { useFhirData } from "@/utils/useFhirData";
import type { AttendanceSpecialtyIndex } from "@/utils/resolveAttendanceSpecialty";

function collectById(entries: any[] | undefined, map: Map<string, any>) {
  entries?.forEach((entry: any) => {
    const resource = entry?.resource || entry;
    if (resource?.id) map.set(resource.id, resource);
  });
}

/**
 * Mapa encounterId/appointmentId a partir dos bundles já carregados no atendimento.
 * Evita N+1 GetEncounter/GetAppointment por linha de histórico.
 */
export function useAttendanceSpecialtyIndex(): AttendanceSpecialtyIndex {
  const { summaryData, encounter, appointment } = useMedicalCareContext();

  return useMemo(() => {
    const encountersById = new Map<string, any>();
    const appointmentsById = new Map<string, any>();

    const encounterEntries = useFhirData.extractPatientSummaryResource(
      summaryData,
      "Encounter",
    )?.[0]?.entry;
    collectById(encounterEntries, encountersById);
    if (encounter?.id) encountersById.set(encounter.id, encounter);

    const appointmentEntries = useFhirData.extractPatientSummaryResource(
      summaryData,
      "Appointment",
    )?.[0]?.entry;
    collectById(appointmentEntries, appointmentsById);
    if (appointment?.id) appointmentsById.set(appointment.id, appointment);

    return { encountersById, appointmentsById };
  }, [summaryData, encounter, appointment]);
}
